import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Select from 'react-select'

class AdminAddPickUp extends React.Component {
  state = {
    pickup_desc: '',
    pickup_lat: '',
    pickup_long: '',
    pickup_address_en: '',
    pickup_address_ar: '',
    pickup_other_detail: '',
    pickup_vendor_charge: '',
    pickup_vendor_id: '',
    is_active: false,
    isData: false,
    city_list: [],
    city_data: {},
  }

  async componentDidMount() {
    await this.getVendors()
    await this.getCities()
    await this.dashbord()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  dashbord = async () => {
    this.setState({ isloading: true })

    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.pickupId)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
              city_data: this.state.city_list.find((ele) => ele.value === itm.city_id) || null,
            })
          }
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addPickUp = () => {
    var that = this
    that.setState({ isSaving: true })
    var data = {
      pickup_desc: that.state.pickup_desc,
      pickup_lat: that.state.pickup_lat,
      pickup_long: that.state.pickup_long,
      pickup_address_ar: that.state.pickup_address_ar,
      pickup_address_en: that.state.pickup_address_en,
      pickup_other_detail: that.state.pickup_other_detail,
      is_active: that.state.is_active,
      pickup_vendor_charge: that.state.pickup_vendor_charge,
      pickup_vendor_id: that.state.pickup_vendor_id,
      city_id: that.state.city_data?.value,
    }

    if (this.props.pickupId) {
      this.setState({ isData: true })
      var data1 = {
        ...data,
        id: this.props.pickupId,
      }
      axios
        .put(Constant.getAPI() + '/admin/update-pick-up', data1, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            this.setState({ isData: false })
            Swal.fire({
              title: 'PickUp Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/pick-up-list`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({ isData: true })
      axios
        .post(Constant.getAPI() + '/admin/add-pick-up', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'PickUp Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/pick-up-list`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  getVendors = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/admin/list-users/vendor', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Vendors_List: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addPickUp()
  }

  getCities = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/city`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            city_list: res.data.data
              ?.filter((ele) => ele.is_deleted === false)
              .map((itm) => ({
                label: `${itm.name_en}/${itm.name_ar}`,
                value: itm.id,
              })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCityChange = (event) => {
    this.setState({ city_data: event })
  }

  handleClear = () => {
    this.setState({ city_data: null })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="pickup_desc"
                    placeholder="Description"
                    onChange={this.handleChange}
                    value={this.state.pickup_desc}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Latitude</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="pickup_lat"
                    placeholder="Latitude"
                    onChange={this.handleChange}
                    value={this.state.pickup_lat}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Longitude</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="pickup_long"
                    placeholder="Longitude"
                    onChange={this.handleChange}
                    value={this.state.pickup_long}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address : English</label>
                <div className="col-sm-9">
                  <textarea
                    type="number"
                    className="form-control"
                    name="pickup_address_en"
                    placeholder="Address"
                    onChange={this.handleChange}
                    value={this.state.pickup_address_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address : Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    type="number"
                    className="form-control"
                    name="pickup_address_ar"
                    placeholder="Address"
                    onChange={this.handleChange}
                    value={this.state.pickup_address_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Other Details</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="pickup_other_detail"
                    placeholder="Other Details"
                    onChange={this.handleChange}
                    value={this.state.pickup_other_detail}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Vendor</label>
                <div className="col-sm-9">
                  <select
                    name="pickup_vendor_id"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.pickup_vendor_id}
                  >
                    <option>Select Vendor</option>
                    {this.state.Vendors_List !== undefined &&
                    this.state.Vendors_List !== null &&
                    this.state.Vendors_List !== [] &&
                    this.state.Vendors_List.length > 0
                      ? this.state.Vendors_List.map((Vendors_List) => (
                          <option
                            value={Vendors_List.id}
                            key={Vendors_List.id}
                          >
                            {Vendors_List.first_name} {Vendors_List.last_name}
                            {'/'}
                            {Vendors_List.first_name_ar} {Vendors_List.last_name_ar}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Vendor Charge</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="pickup_vendor_charge"
                    placeholder="vendor charge"
                    onChange={this.handleChange}
                    value={this.state.pickup_vendor_charge}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Select Area</label>
                <div className="col-sm-9">
                  <Select
                    name="city_data"
                    value={this.state.city_data}
                    onChange={this.handleCityChange}
                    options={this.state.city_list}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleClear}
                    placeholder="Select Options"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false">InActive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/pick-up-list`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdminAddPickUp
